import { tickerItems } from "@/mocks/homeData";

export default function TopTicker() {
  const loopItems = [...tickerItems, ...tickerItems];

  return (
    <div className="sticky top-0 z-50 bg-foreground-950 text-background-50 dark:text-foreground-950">
      <div className="mx-auto flex h-10 max-w-[1400px] items-center gap-3 px-4 md:px-6">
        <span className="flex shrink-0 items-center gap-1.5 rounded-full bg-primary-500 px-2.5 py-1 text-[11px] font-semibold tracking-wide text-background-50 dark:text-foreground-950">
          <span className="flex h-2 w-2 items-center justify-center">
            <span className="live-dot h-2 w-2 rounded-full bg-background-50 dark:bg-foreground-950" />
          </span>
          实时更新
        </span>

        <div className="relative min-w-0 flex-1 overflow-hidden">
          <div className="ticker-track flex w-max items-center">
            {loopItems.map((item, index) => (
              <span
                key={`${item}-${index}`}
                className="flex shrink-0 items-center whitespace-nowrap pr-10 text-xs text-background-100 dark:text-foreground-200 md:text-[13px]"
              >
                <i className="ri-fire-fill mr-1.5 text-accent-400" />
                {item}
              </span>
            ))}
          </div>
        </div>

        <nav className="hidden shrink-0 items-center gap-1 lg:flex">
          <a
            href="#ranking"
            className="flex items-center gap-1 rounded-md px-2.5 py-1 text-xs text-background-100 transition-colors hover:bg-background-50/10 hover:text-background-50 dark:text-foreground-200 dark:hover:text-foreground-950"
          >
            <i className="ri-bar-chart-2-line" />
            热榜
          </a>
          <a
            href="#topics"
            className="flex items-center gap-1 rounded-md px-2.5 py-1 text-xs text-background-100 transition-colors hover:bg-background-50/10 hover:text-background-50 dark:text-foreground-200 dark:hover:text-foreground-950"
          >
            <i className="ri-hashtag" />
            话题墙
          </a>
          <a
            href="#buzz"
            className="flex items-center gap-1 rounded-md bg-accent-500 px-2.5 py-1 text-xs font-medium text-foreground-950 transition-colors hover:bg-accent-400"
          >
            <i className="ri-send-plane-fill" />
            我要爆料
          </a>
        </nav>
      </div>
    </div>
  );
}